export default __webpack_public_path__ + "static/media/leisure.690039b9.svg";